
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorWaterPhGoogle as ObiSensorWaterPhGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-water-ph-google.js';
 
 
 

 
 export const ObiSensorWaterPhGoogle = createComponent({
   react: React,
   tagName: 'obi-sensor-water-ph-google',
   elementClass: ObiSensorWaterPhGoogleElement,
   events: {
     
   }
  });
 
 